if ($(".type-category").length) {
    if($('.category-perex').length){
        if($('.category-perex .pruvodce').length){
            $('.category-perex').addClass('havePruvodce')
        }
    }

}


